<mat-accordion>
  <mat-expansion-panel
    [expanded]="panelOpenState"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false">

    <mat-expansion-panel-header>
      <mat-panel-title *ngIf="!panelOpenState">
        ➕ Clique para adicionar novos itens
      </mat-panel-title>
      <mat-panel-title *ngIf="panelOpenState">
        Adicione novos itens 👇
      </mat-panel-title>
      <mat-panel-description></mat-panel-description>
    </mat-expansion-panel-header>

    <form [formGroup]="itemForm">
      <div class="row">
        <mat-form-field class="form-group col-md-2">
          <mat-label>Quantidade</mat-label>
          <input type="number" matInput formControlName="quantidade" #qtdComercial appRequiredField>
        </mat-form-field>

        <mat-form-field class="col-md-5 col-xs-12 form-group">
          <mat-label>Serviço/Produto que será adicionado</mat-label>
          <input type="text" matInput formControlName="item" [matAutocomplete]="item" appRequiredField>

          <mat-autocomplete
            #item="matAutocomplete"
            [displayWith]="displayItemFn"
            (optionSelected)="onItemSelected($event.option.value)">

            <mat-option *ngFor="let produto of filteredProdutos" [value]="produto">
              {{ produto.codProd }} - {{ produto.descricao }}
            </mat-option>

            <mat-option
              *ngIf="(!(filteredProdutos?.length > 0) && (itemForm?.get('item')?.value?.length >= 3)) && !permitirItemSemId"
              class="nao-encontrado">
              ❌ Produto/Serviço não localizado nas filiais selecionadas.
            </mat-option>
          </mat-autocomplete>

          <mat-hint class="custom-hint">
            🔎 Digite 3 letras que existam sequencialmente no Nome ou no Código do Serviço/Produto desejado para receber as sugestões do sistema.
          </mat-hint>
        </mat-form-field>

        <div *ngIf="itemForm.get('item')?.value?.produtoId > 0 || permitirItemSemId">
          <mat-form-field class="form-group col-md-4">
            <mat-label>Valor Unitário</mat-label>
            <input currencyMask matInput formControlName="valorUnitario" appRequiredField>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div *ngIf="itemForm.get('item')?.value?.produtoId > 0 || permitirItemSemId">
          <mat-form-field class="form-group col-md-3">
            <mat-label>Desconto Unitário</mat-label>
            <input currencyMask matInput formControlName="descontoUnitario" appRequiredField>
          </mat-form-field>

          <mat-form-field class="form-group col-md-3">
            <mat-label>Valor Total Bruto</mat-label>
            <input matInput currencyMask formControlName="valorTotalBruto" appRequiredField>
          </mat-form-field>

          <mat-form-field class="form-group col-md-3">
            <mat-label>Valor Total Líquido</mat-label>
            <input matInput currencyMask formControlName="valorTotalLiquido" appRequiredField>
          </mat-form-field>

          <div class="form-group col-md-1" style="display: flex; align-items: center; margin-top: 20px;">
            <button
              mat-mini-fab
              matTooltip="Adicionar Item"
              (click)="addItem()"
              [disabled]="!(itemForm.get('item')?.value?.produtoId > 0 || permitirItemSemId) || itemForm.invalid">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>

<hr>

<div *ngIf="itensTabela.data?.length > 0">
  <div class="row">
    <h3>Itens adicionados:</h3>

    <mat-table
      [dataSource]="itensTabela"
      [multiTemplateDataRows]="permitirSubitens"
      class="items-table">

      <ng-container matColumnDef="expanderCol">
        <mat-header-cell *matHeaderCellDef class="expander-col"></mat-header-cell>
        <mat-cell *matCellDef="let element" class="expander-col">
          <button
            mat-icon-button
            *ngIf="!element.detailRow && itens[element._itemIndex]?.subitens?.length > 0"
            (click)="toggleExpand(element._itemIndex)"
            [matTooltip]="isExpanded(element._itemIndex) ? 'Recolher' : 'Expandir subitens'">
            <mat-icon>
              {{ isExpanded(element._itemIndex) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="quantidade">
        <mat-header-cell *matHeaderCellDef>Quantidade</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Quantidade'">
          <span *ngIf="editingIndex !== element._itemIndex">{{ element.quantidade }}</span>

          <ng-container *ngIf="editingIndex === element._itemIndex">
            <span *ngIf="itemTemSubitens(element._itemIndex)">{{ element.quantidade }}</span>

            <mat-form-field
              *ngIf="!itemTemSubitens(element._itemIndex)"
              appearance="outline"
              class="cell-field">
              <input type="number" matInput [formControl]="editQuantidade">
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <mat-header-cell *matHeaderCellDef class="col-descricao">Nome</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Nome'" class="col-descricao">
          <span *ngIf="editingIndex !== element._itemIndex">
            {{ element.descricao }}
            <span
              *ngIf="itens[element._itemIndex]?.subitens?.length > 0"
              class="subitem-badge"
              [matTooltip]="'Este item possui ' + itens[element._itemIndex].subitens.length + ' subiten(s)'">
              {{ itens[element._itemIndex].subitens.length }}
              {{ itens[element._itemIndex].subitens.length === 1 ? 'subitem' : 'subitens' }}
            </span>
          </span>

          <ng-container *ngIf="editingIndex === element._itemIndex">
            <!-- Campo de edição do nome -->
            <mat-form-field
              *ngIf="!changingProduct"
              appearance="outline"
              class="cell-field cell-field-descricao">
              <input type="text" matInput [formControl]="editDescricao">
              <mat-hint *ngIf="!_selectedEditProduct && getEditingItemProductName()">
                Mapeado com o Produto/Serviço: {{ getEditingItemProductName() }} ·
                <a class="trocar-produto-link" (click)="startChangeProduct()">alterar</a>
              </mat-hint>
              <mat-hint *ngIf="!_selectedEditProduct && !getEditingItemProductName()">
                <a class="trocar-produto-link" (click)="startChangeProduct()">vincular produto</a>
              </mat-hint>
              <mat-hint *ngIf="_selectedEditProduct">
                Mapeado com o Produto/Serviço: {{ _selectedEditProduct.descricao }} ·
                <a class="trocar-produto-link" (click)="startChangeProduct()">alterar</a>
              </mat-hint>
            </mat-form-field>

            <!-- Autocomplete para trocar produto -->
            <mat-form-field
              *ngIf="changingProduct"
              appearance="outline"
              class="cell-field cell-field-descricao">
              <input
                type="text"
                matInput
                [formControl]="editProdutoSearch"
                [matAutocomplete]="editProdutoAuto"
                placeholder="Buscar novo produto...">

              <mat-autocomplete
                #editProdutoAuto="matAutocomplete"
                [displayWith]="displayEditProductFn"
                (optionSelected)="onEditProductSelected($event.option.value)">

                <mat-option *ngFor="let produto of filteredEditProdutos" [value]="produto">
                  {{ produto.codProd }} - {{ produto.descricao }}
                </mat-option>

                <mat-option
                  *ngIf="(!(filteredEditProdutos?.length > 0) && (editProdutoSearch?.value?.length >= 3))"
                  class="nao-encontrado">
                  Produto/Serviço não localizado nas filiais selecionadas.
                </mat-option>
              </mat-autocomplete>
              <mat-hint>
                <a class="trocar-produto-link cancelar" (click)="cancelChangeProduct()">cancelar troca</a>
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="valorUnitario">
        <mat-header-cell *matHeaderCellDef>Valor Unitário</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Valor Unitário'">
          <span *ngIf="editingIndex !== element._itemIndex">{{ element.valorUnitario }}</span>

          <ng-container *ngIf="editingIndex === element._itemIndex">
            <span *ngIf="itemTemSubitens(element._itemIndex)">{{ element.valorUnitario }}</span>

            <mat-form-field
              *ngIf="!itemTemSubitens(element._itemIndex)"
              appearance="outline"
              class="cell-field">
              <input currencyMask matInput [formControl]="editValorUnitario">
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descontoUnitario">
        <mat-header-cell *matHeaderCellDef>Valor Desc. Unitário</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Valor Desc. Unitário'">
          <span *ngIf="editingIndex !== element._itemIndex">{{ element.descontoUnitario }}</span>

          <ng-container *ngIf="editingIndex === element._itemIndex">
            <span *ngIf="itemTemSubitens(element._itemIndex)">
              {{ element.descontoUnitario }}
            </span>

            <mat-form-field
              *ngIf="!itemTemSubitens(element._itemIndex)"
              appearance="outline"
              class="cell-field">
              <input currencyMask matInput [formControl]="editDescontoUnitario">
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="valorTotalBruto">
        <mat-header-cell *matHeaderCellDef>Valor Total Bruto</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Valor Total Bruto'">
          <span *ngIf="editingIndex !== element._itemIndex">{{ element.valorTotalBruto }}</span>
          <span *ngIf="editingIndex === element._itemIndex">
            {{ editValorTotalBruto | currency:'BRL':'symbol' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="valorTotalLiquido">
        <mat-header-cell *matHeaderCellDef>Valor Total Líquido</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-label]="'Valor Total Líquido'">
          <span *ngIf="editingIndex !== element._itemIndex">{{ element.valorTotalLiquido }}</span>
          <span *ngIf="editingIndex === element._itemIndex">
            {{ editValorTotalLiquido | currency:'BRL':'symbol' }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="acaoTable">
        <mat-header-cell *matHeaderCellDef>Ações</mat-header-cell>

        <mat-cell *matCellDef="let element" [attr.data-label]="'Ações'">
          <ng-container *ngIf="editingIndex !== element._itemIndex">
            <ng-container *ngIf="temAcoesMenu() && !element.detailRow">
              <button
                mat-icon-button
                [matMenuTriggerFor]="itemMenu"
                (click)="openItemMenu(element._itemIndex)"
                matTooltip="Ações"
                class="btn-acao">
                <mat-icon>more_vert</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="!element.detailRow">
              <button
                [disabled]="BloquearEdicao"
                mat-mini-fab
                [color]="BloquearEdicao ? null : 'primary'"
                matTooltip="Editar"
                (click)="startEdit(element._itemIndex)"
                class="btn-acao">
                <mat-icon>edit</mat-icon>
              </button>

              <button
                [disabled]="BloquearEdicao"
                mat-mini-fab
                color="warn"
                matTooltip="Excluir"
                (click)="removeItem(element._itemIndex)"
                class="btn-acao">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="editingIndex === element._itemIndex && !element.detailRow">
            <button
              mat-mini-fab
              color="primary"
              matTooltip="Salvar"
              (click)="saveEdit()"
              class="btn-acao">
              <mat-icon>check</mat-icon>
            </button>

            <button
              mat-mini-fab
              color="warn"
              matTooltip="Cancelar"
              (click)="cancelEdit()"
              class="btn-acao">
              <mat-icon>close</mat-icon>
            </button>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <mat-cell
          *matCellDef="let row"
          [attr.colspan]="columnsToDisplay.length"
          class="detail-cell">

          <div
            class="detail-content"
            *ngIf="isExpanded(row._itemIndex) || addingSubitemIndex === row._itemIndex">

            <div *ngIf="itens[row._itemIndex]?.subitens?.length > 0" class="subitem-wrapper">
              <p class="subitem-label">
                <mat-icon style="vertical-align: middle; font-size: 16px;">account_tree</mat-icon>
                Detalhamento do Item (Subitens)
              </p>

              <table class="subitem-table">
                <thead>
                  <tr>
                    <th>Descrição</th>
                    <th class="sub-col-num">Quantidade</th>
                    <th class="sub-col-num">Valor Unitário</th>
                    <th class="sub-col-num">Desc. Unitário</th>
                    <th class="sub-col-num">Valor Total Bruto</th>
                    <th class="sub-col-num">Valor Total Líquido</th>
                    <th class="sub-col-acoes">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let sub of itens[row._itemIndex].subitens; let si = index">

                    <ng-container *ngIf="!isEditingSubitem(row._itemIndex, si)">
                      <td>{{ sub.descricao }}</td>
                      <td class="sub-col-num">{{ sub.quantidade }}</td>
                      <td class="sub-col-num">{{ sub.valorUnitario | currency:'BRL':'symbol' }}</td>
                      <td class="sub-col-num">{{ (sub.valorDescontoUnitario ?? sub.descontoUnitario ?? 0) | currency:'BRL':'symbol' }}</td>
                      <td class="sub-col-num">{{ sub.valorTotalBruto | currency:'BRL':'symbol' }}</td>
                      <td class="sub-col-num">{{ (sub.valorTotalLiquido || sub.valorTotalBruto) | currency:'BRL':'symbol' }}</td>
                      <td class="sub-col-acoes">
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="subitemMenu"
                          (click)="openSubitemMenu(row._itemIndex, si)"
                          matTooltip="Ações"
                          class="btn-acao">
                          <mat-icon>more_vert</mat-icon>
                        </button>

                        <button
                          mat-mini-fab
                          color="primary"
                          matTooltip="Editar"
                          (click)="startEditSubitem(row._itemIndex, si)"
                          class="btn-acao">
                          <mat-icon>edit</mat-icon>
                        </button>

                        <button
                          mat-mini-fab
                          color="warn"
                          matTooltip="Excluir"
                          (click)="removeSubitem(row._itemIndex, si)"
                          class="btn-acao">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                    <ng-container *ngIf="isEditingSubitem(row._itemIndex, si)">
                      <td>
                        <mat-form-field appearance="outline" class="sub-cell-field sub-cell-field-desc">
                          <input type="text" matInput [formControl]="editSubDescricao">
                        </mat-form-field>
                      </td>

                      <td class="sub-col-num">
                        <mat-form-field appearance="outline" class="sub-cell-field">
                          <input type="number" matInput [formControl]="editSubQuantidade">
                        </mat-form-field>
                      </td>

                      <td class="sub-col-num">
                        <mat-form-field appearance="outline" class="sub-cell-field">
                          <input currencyMask matInput [formControl]="editSubValorUnitario">
                        </mat-form-field>
                      </td>

                      <td class="sub-col-num">
                        <mat-form-field appearance="outline" class="sub-cell-field">
                          <input currencyMask matInput [formControl]="editSubDescontoUnitario">
                        </mat-form-field>
                      </td>

                      <td class="sub-col-num">
                        <mat-form-field appearance="outline" class="sub-cell-field">
                          <input currencyMask matInput [formControl]="editSubValorTotalBrutoControl" readonly>
                        </mat-form-field>
                      </td>

                      <td class="sub-col-num">
                        <mat-form-field appearance="outline" class="sub-cell-field">
                          <input currencyMask matInput [formControl]="editSubValorTotalLiquidoControl" readonly>
                        </mat-form-field>
                      </td>

                      <td class="sub-col-acoes">
                        <button
                          mat-mini-fab
                          color="primary"
                          matTooltip="Salvar"
                          (click)="saveEditSubitem()"
                          class="btn-acao">
                          <mat-icon>check</mat-icon>
                        </button>

                        <button
                          mat-mini-fab
                          color="warn"
                          matTooltip="Cancelar"
                          (click)="cancelEditSubitem()"
                          class="btn-acao">
                          <mat-icon>close</mat-icon>
                        </button>
                      </td>
                    </ng-container>

                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="addingSubitemIndex === row._itemIndex" class="subitem-container">
              <div *ngIf="addingSubitemIndex === row._itemIndex" class="subitem-add-form">
                <p class="subitem-label">
                  <mat-icon style="vertical-align: middle; font-size: 16px;">add_circle_outline</mat-icon>
                  Novo Subitem
                </p>

                <div class="subitem-add-row">
                  <mat-form-field appearance="outline" class="sub-form-field sub-form-desc">
                    <mat-label>Descrição</mat-label>
                    <input
                      type="text"
                      matInput
                      [formControl]="subItemInput"
                      [matAutocomplete]="subItemAuto"
                      placeholder="Ex: Consultoria Administrativa - Dia 1">

                    <mat-autocomplete
                      #subItemAuto="matAutocomplete"
                      [displayWith]="displaySubItemFn"
                      (optionSelected)="onSubItemSelected($event.option.value)">

                      <mat-option *ngFor="let produto of filteredSubProdutos" [value]="produto">
                        {{ produto.codProd }} - {{ produto.descricao }}
                      </mat-option>

                      <mat-option
                        *ngIf="(!(filteredSubProdutos?.length > 0) && (subItemInput?.value?.length >= 3)) && !permitirItemSemId"
                        class="nao-encontrado">
                        ❌ Produto/Serviço não localizado nas filiais selecionadas.
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="sub-form-field sub-form-num">
                    <mat-label>Quantidade</mat-label>
                    <input type="number" matInput [formControl]="subQuantidade">
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="sub-form-field sub-form-num">
                    <mat-label>Valor Unitário</mat-label>
                    <input currencyMask matInput [formControl]="subValorUnitario">
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="sub-form-field sub-form-num">
                    <mat-label>Desconto Unitário</mat-label>
                    <input currencyMask matInput [formControl]="subDescontoUnitario">
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="sub-form-field sub-form-num">
                    <mat-label>Valor Total Bruto</mat-label>
                    <input matInput currencyMask [formControl]="subValorTotalBrutoControl" readonly>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="sub-form-field sub-form-num">
                    <mat-label>Valor Total Líquido</mat-label>
                    <input matInput currencyMask [formControl]="subValorTotalLiquidoControl" readonly>
                  </mat-form-field>

                  <div class="sub-form-actions">
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="addSubitem(row._itemIndex)"
                      [disabled]="subitemForm.invalid">
                      + Adicionar
                    </button>

                    <button mat-raised-button (click)="hideAddSubitem()">
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay; when: mainRowWhen"></mat-row>
      <mat-row *matRowDef="let row; columns: ['expandedDetail']; when: detailRowWhen" class="detail-row"></mat-row>
    </mat-table>

    <mat-menu #itemMenu="matMenu">
      <button
        mat-menu-item
        *ngIf="permitirSubitens"
        (click)="onAdicionarSubitemMenu()">
        <mat-icon>add</mat-icon>
        Adicionar Subitem
      </button>

      <button
        mat-menu-item
        (click)="onFormaEntregaItemMenu()">
        <mat-icon>local_shipping</mat-icon>
        Forma de Entrega
      </button>

      <button
        mat-menu-item
        *ngFor="let acao of acoesExtras"
        (click)="executarAcaoMenu(acao)">
        <mat-icon *ngIf="acao.icone">{{ acao.icone }}</mat-icon>
        {{ acao.nome }}
      </button>
    </mat-menu>

    <mat-menu #subitemMenu="matMenu">
      <button
        mat-menu-item
        (click)="onFormaEntregaSubitemMenu()">
        <mat-icon>local_shipping</mat-icon>
        Forma de Entrega
      </button>
    </mat-menu>
  </div>
</div>
